// React
import { useEffect, useState } from "react";

// React redux
import { useSelector } from "react-redux";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Custum dialog
import DeleteDialog from "layouts/users/components/modalDelete";
import ModalEdit from "layouts/users/components/modalEdit";

const columns = [
  { Header: "Email", accessor: "email", align: "left" },
  { Header: "Nom et Prénom", accessor: "fullname", align: "left" },
  { Header: "Télephone", accessor: "tel", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];

export default function UsersTableData() {
  const users = useSelector((state) => state.user.allUsers);
  const [currentUser, setCurrentUser] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [authorList, setAuthorList] = useState([]);

  const finished = () => {
    setDialog(null);
    setCurrentUser(null);
  };

  const filterAuthor = () => {
    let utilisator = users;
    utilisator = utilisator.filter((u) => u.roles.includes("ROLE_AUTHOR"));
    return utilisator;
  };

  useEffect(() => {
    setAuthorList(filterAuthor());
  }, [users]);

  const rows = authorList.map((user) => ({
    email: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {user.email}
      </MDTypography>
    ),
    fullname: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {user.fullname}
      </MDTypography>
    ),
    tel: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {user.tel}
      </MDTypography>
    ),
    action: (
      <MDBox component="div" sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentUser(user);
            setDialog("edit");
          }}
        >
          Editer
        </MDTypography>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentUser(user);
            setDialog("remove");
          }}
        >
          Supprimer
        </MDTypography>
      </MDBox>
    ),
  }));

  return (
    <>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
      {dialog === "edit" && <ModalEdit user={currentUser} finished={finished} />}
      {dialog === "remove" && <DeleteDialog userId={currentUser.id} finished={finished} />}
    </>
  );
}
